<br/>
<div style="text-align: center;">

    <h1>Pagos Convenio</h1>
</div>
<br/>



<div class="container principal" id="tabla" style="background-color: white; padding-top: 10px; padding-bottom:50px;">

    <div class="container principal">
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">

            <div class="row">

                <div class="col-lg-4"> Afiliado:</div>

                <div class="col-lg-8">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>

                </div>

            </div>

        </div>
        <div *ngIf="rol != 'ROLE_AFILIADO'">

            <div class="row line">

                <div class="col-lg-2"> </div>

                <div class="col-lg-2">
                    <h2> Rut Afiliado </h2>
                </div>

                <div class="col-lg-4">

                    <input id="rutAfiliado" name="rutAfiliado" [(ngModel)]="buscador.rutAfiliado" #rutAfiliado="ngModel" class="form-control" type="text" required placeholder="Ingrese el RUT del afiliado. Ej: 11111111-1" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />

                </div>

                <div class="col-lg-4">

                    <button class="btn btn-primary" id="btnBuscarAfiliado" name="btnBuscarAfiliado" (click)="buscaAfiliado(this.rutAfiliado.value)">
    
                        Buscar
    
                    </button>

                </div>
            </div>
            <div class="row line">

                <div class="col-lg-4"> </div>
                <div class="col-lg-5">
                    <h2>{{this.afiliado.nombreAfiliado}} {{this.afiliado.rutAfiliado}}
                    </h2>
                </div>
            </div>
        </div>

    </div>
    <br/>


    <div class="row line">
        <div class="col-lg-1"> </div>
        <div class="col-lg-3">
            <h2>Convenios Disponibles</h2>
        </div>

    </div>
    <div class="table-responsive">

        <table class="table" id="tablaPlan" name="tablaPlan">

            <thead style="background-color: #0f69b4;color:white;">
                <tr>
                    <th style="text-align: center;">ID Postulacion</th>
                    <th style="text-align: center;">Fecha de Creación</th>
                    <th style="text-align: center;">Fecha de Pago</th>
                    <th style="text-align: center;">Tipo Convenio</th>
                    <th style="text-align: center;">Monto Solicitado</th>
                    <th style="text-align: center;">Cantidad Cuotas</th>
                    <th style="text-align: center;">Codeudor Uno</th>
                    <th style="text-align: center;">Codeudor Dos</th>
                    <th style="text-align: center;">Proveedor</th>
                    <th style="text-align: center;">Ver Pagos</th>
                    <th style="text-align: center;" *ngIf="rol != 'ROLE_AFILIADO' && rol != 'ROLE_JUBILADO'">Anular/Reversar</th>
                </tr>
            </thead>
            <tbody>


                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let prestamo of this.convenios | paginate: config; let i = index">
                    <td style="text-align: center;"><a style="cursor:pointer; text-decoration: underline" (click)="openEditDialogValidarConvenio(prestamo.idPostulacion,  false,false)">{{prestamo.idPostulacion}}</a></td>
                    <td style="text-align: center;">{{prestamo.fechaIngreso}}</td>
                    <td style="text-align: center;">{{prestamo.fechaProximoPago}}</td>
                    <td style="text-align: center;">{{prestamo.tipoConvenioString}}</td>
                    <td style="text-align: center;">{{prestamo.montoSolicitado}}</td>
                    <td style="text-align: center;">{{prestamo.cantidadCuota}}</td>
                    <td style="text-align: center;">{{prestamo.nombreCodeudorUno}} {{prestamo.apellidoCodeudorUno}}</td>
                    <td style="text-align: center;">{{prestamo.nombreCodeudorDos}} {{prestamo.apellidoCodeudorDos}}</td>
                    <td style="text-align: center;">{{prestamo.nombreCorto}}</td>
                    <th style="text-align: center">


                        <button class="btn btn-success" id="btnVer" name="btnVer" (click)="verPlanPago(prestamo.idConvenio)">Ver </button>

                    </th>
                    <th style="text-align: center" *ngIf="rol != 'ROLE_AFILIADO' && rol != 'ROLE_JUBILADO' && rol != 'ROLE_EJECUTIVO' && rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_ENCARGADO_NACIONAL' && rol != 'ROLE_ASISTENTE_SOCIAL' &&  rol != 'ROLE_COORDINADOR' &&  rol != 'ROLE_ENCARGADO_REGIONAL'  &&  rol != 'ROLE_ENCARGADO_REGIONAL_CONTABLE'">
                        <button class="btn btn-secondary" id="btnAnular" name="btnAnular" (click)="anularConvenio(prestamo.idPostulacion,prestamo.idUsuario)">Anular/Reversar </button>
                    </th>
                </tr>
            </tbody>
        </table>
        <div *ngIf="rol == 'ROLE_AFILIADO' || rol == 'ROLE_JUBILADO'">
            <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event,this.afiliado.rutAfiliado)" autoHide="true"> </pagination-controls>
        </div>
        <div *ngIf="rol != 'ROLE_AFILIADO'">
            <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event,buscador.rutAfiliado)" autoHide="true"> </pagination-controls>
        </div>  
    </div>
    <br>

    <br/>

    <div class="row line">
        <div class="col-lg-4">
            <h2>Plan de Pago Convenio</h2>
        </div>
    </div>
    <br>


    <div class="table-responsive">

        <table class="table" id="tablaPlan" name="tablaPlan">

            <thead style="background-color: #0f69b4;color:white;">
                <tr>
                    <th style="text-align: center;">Nro. cuota</th>
                    <th style="text-align: center;">Fecha de pago</th>
                    <th style="text-align: center;">Monto Cuota</th>
                    <th style="text-align: center;">Estado</th>
                    <th style="text-align: center;">Fecha modificación</th>
                    <th style="text-align: center;"></th>
                </tr>
            </thead>
            <tbody>
              
               
                <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let plan of this.planes; let i = index">
                    <td style="text-align: center;">
                        <a style="cursor:pointer; text-decoration: underline" (click)="pagarDeuda(plan.idConvenio,plan.numCuota,false,i,plan.idPlanPago,plan.estadoPrevio, plan.fechaPago,plan.idTipoConvenio,plan.idProveedor)">
                            {{plan.numCuota}}</a>
                    </td>
                    <td style="text-align: center;">{{plan.fechaPago}}</td>
                    <td style="text-align: center;">{{plan.montoCuota}}</td>
                    <td style="text-align: center;">{{plan.estado}}</td>
                    <td style="text-align: center;">{{plan.fechaPagoRealString}}</td>
                    <th style="text-align: center">
                        <!-- <div *ngIf="plan.estado=='VIGENTE'"> --> 
                        <div *ngIf="plan.estado=='VIGENTE' && (rol != 'ROLE_EJECUTIVO' && rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_ENCARGADO_NACIONAL')">
                            <button class="btn btn-primary" id="btnPagar" (click)="pagarDeuda(plan.idConvenio,plan.numCuota,true,i,plan.idPlanPago,plan.estadoPrevio, plan.fechaPago,plan.idTipoConvenio,plan.idProveedor)">Pagar</button>
                        </div>
                    </th>
                </tr>
        </table>
    </div>
</div>





<br/><br/><br/>